<template>
  <ValidationObserver ref="form">
    <form v-if="!emailSent" @submit.prevent="submit">
      <z-input v-model="username" type="text" name="username" label="Username" :validator="v$.username" />
      <z-input v-model="password" type="password" name="password" label="Password" :validator="v$.password" />
      <div class="custom-button">
        <button type="submit" class="btn btn-primary btn-block" :disabled="isLoading">
          <div class="custom-button-text">
            <span>Log In</span>
            <div v-show="isLoading" class="ms-2">
              <i class="fa-solid fa-spinner fa-spin"></i>
            </div>
          </div>
        </button>
      </div>
      <div class="custom-button">
        <button v-if="isFailedLogin" type="submit" class="btn btn-primary btn-block mt-2" :disabled="isLoading"
          @click="passwordReset">
          Forgot my Password
        </button>
      </div>
      <z-message v-model="message" class="alert alert-warning mt-2" />
    </form>
    <div v-else class="row">
      <div class="col">
        <div class="row">
          <div class="col">
            <p>No problem, a "Reset Password" link has been sent to your registered email address.</p>
            <p>Please look for that email and click the link to reset your password. You may need to check your spam
              folder.</p>
          </div>
        </div>
      </div>
    </div>
  </ValidationObserver>
  <div v-if="userRequiresEulaAcceptance" class="eulaWrapper">
      <div class="eulaContainer">
        <div class="eulaLoading" v-show="isLoadingEULA">
          <div class="loadingWrapper">
            <i class="fa fa-spinner fa-spin"></i>
            <span>Please Wait...</span>
          </div>
        </div>

        <div class="eulaHeader">
          <h5>{{eulaType}} End User License Agreement </h5>
          <span class="eulaVersion">Version: {{ eulaVersion }}, Updated: {{ getSimpleFormattedDate(eulaDate)}}</span>
        </div>
        <div ref="eulaBox" class="row eulaContent" v-html="eulaContent" @scroll.passive="onEulaScroll">
        </div>
        <div class="row">
          <button @click="acceptEULA" class="btn btn-primary btn-block" :disabled="!eulaRead">Accept</button>
          <button @click="denyEULA"   class="btn btn-secondary btn-block">Deny</button>
        </div>
      </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { authStore } from '@/stores/auth'
import ZInput from '@/components/utilities/elements/Input.vue'
import ZMessage from '@/components/utilities/elements/Message.vue'
export default {
  name: 'FormLogin',
  components: {
    ZInput,
    ZMessage
  },
  data() {
    return {
      message: '',
      rules: {
        username: { required },
        password: { required }
      },
      v$: null,
      isLoading: false,
      isLoadingEULA: false,
      isFailedLogin: false,
      emailSent: false,
      path: '',
      userRequiresEulaAcceptance: false,
      currentEULA: null,
      eulaType: null,
      eulaDate: null,
      eulaVersion: null,
      eulaContent: null,
      eulaRead: false      
    }
  },
  beforeMount() {
    this.v$ = useVuelidate(this.rules, this.profile)
    this.isLoading = false
  },
  computed: {
    ...mapState(authStore, ['profile', 'token', 'passthrough']),
    username: {
      get() {
        let _data = null
        if (this.profile) {
          _data = this.profile.username
        }
        return _data
      },
      set(value) {
        this.setData({
          name: 'username',
          value: value
        })
      }
    },
    password: {
      get() {
        let _data = null
        if (this.profile) {
          _data = this.profile.password
        }
        return _data
      },
      set(value) {
        this.setData({
          name: 'password',
          value: value
        })
      }
    }
  },
  methods: {
    ...mapActions(authStore, ['login', 'clearToken', 'setData', 'resetPassword', 'acceptEula']),
    loginAgain() {
      this.isLoading = false
      this.isFailedLogin = false
      this.emailSent = false
    },
    async passwordReset() {
      this.emailSent = false
      if (this.username.trim() !== '') {
        this.emailSent = true
        let result = await this.resetPassword({
          username: this.username.trim()
        })
        if (result) {
          if (result.success) {
            // let page = `/reset?username=${result.username}&user=${result.user}&contact=${result.contact}&firstname=${result.firstname}&lastname=${result.lastname}`
            // this.$router.push(page)
          } else {
            this.emailSent = false
            this.isLoading = false
            this.message = ''
            this.isFailedLogin = false
            alert('Failed to generate a password reset, please contact support.')
          }
        } else {
          this.emailSent = false
          this.isLoading = false
          this.message = ''
          this.isFailedLogin = false
          alert('An error occurred, please contact support.')
        }
      } else {
        this.emailSent = false
        this.isLoading = false
        this.message = ''
        this.isFailedLogin = false
        this.message = 'Please supply your username/email.'
      }
    },
    async submit() {
      try {
        this.message = ''
        const valid = await this.v$.$validate()
        if (valid) {
          this.isLoading = true
          await this.login(this.username, this.password)
          if (this.token !== '') {
          }
          this.isLoading = false
          this.path = this.passthrough || '/inspections'
          this.determineNextSteps()
        } else {
          console.log('Login Failed')
        }
      } catch (e) {
        this.isLoading = false
        this.isFailedLogin = true
        // TODO: This error message should come from the API
        // TODO: Use of toast
        console.error(e)
        this.message = 'Error: Unable to login'
      }
    },
    async determineNextSteps() {
      this.isLoadingEULA = true
      console.log("Determining Next Steps... Profile ", this.profile.requiredEULAs)
      
      if(this.profile.requiredEULAs && this.profile.requiredEULAs.length > 0) {
        this.userRequiresEulaAcceptance = true
        this.currentEULA = this.profile.requiredEULAs[0];
        this.openEula(this.currentEULA);
      } else {
        this.$router.push(this.path)
      }
    },
    async openEula(eula){
      document.querySelectorAll(".eulaContent").forEach(el => {
        el.scrollTo({ top: 0, behavior: "smooth" });
      });
      this.eulaType = eula.EULAType
      this.eulaDate = eula.CreatedOn
      this.eulaVersion = eula.Version
      this.eulaContent = eula.Content
      this.eulaRead = false
      this.isLoadingEULA = false
    },
    async acceptEULA() {
      this.isLoadingEULA = true
      await this.acceptEula(this.currentEULA)
      this.resetEULA()
      this.determineNextSteps()
    },
    async denyEULA() {
      this.clearToken()
      this.resetEULA()
      window.location.assign('/')
    },
    getSimpleFormattedDate(date) {
      return date.slice(0, 10) 
    },
    resetEULA() {
      this.currentEULA = null
      this.eulaType = null
      this.eulaDate = null
      this.eulaVersion = null
      this.eulaContent = null
      this.userRequiresEulaAcceptance = false
    },
    allowEULA() {
      this.eulaAcceptEnabled = true
    },
    onEulaScroll(e) {
      const el = e.target;
      const threshold = 8; // px wiggle room
      const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - threshold;

      if (atBottom && !this.eulaRead) {
        this.eulaRead = true;
        this.allowEULA(); // enable checkbox/button/etc
      }
    },
  }
}
</script>
<style lang="scss" scoped="true">
.custom-button {
  width: 100%;
  text-align: center;
}
.custom-button-text {
  display: inline-flex;
}

.eulaWrapper {
  background-color: #0000008f;
  width: 100%;
  height: 100%;
  position: fixed;
  inset: 0;
  display:grid;
  place-items: center;
}
.eulaContainer {
  width: 80%; 
  height: 80%;
  background: #eee;
  border-radius: 12px;
  padding: 10px 24px ;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  overflow:auto;
}
.eulaContainer .eulaHeader
{
  text-align: center;
}

.eulaContainer .eulaHeader h5 {
  display:block;
}
.eulaContainer .eulaHeader .eulaVersion {
  font-size: small;
  font-style: italic;
}

.eulaContainer .eulaContent{
  background: white;
  border: 1px solid #ccc;
  height: 80%;
  padding: 0.5em;  
  overflow:auto;
}

.eulaContainer :last-child.row {
  padding-top:1em;
  position:relative;
  bottom:0px;
}

.eulaContainer .btn-secondary {
  margin-top:4px;
}

.eulaLoading { 
  background: rgba(0, 0, 0, 0.40);
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 9999;
  
}

.loadingWrapper{ 
    background: #FFF;
    text-align: center;
    width: 150px;
    border: 1px solid;
    border-radius: 4px;
    padding: 1em;
    position: fixed;
    left: 50%;
    top: 50%;
}

.loadingWrapper span { 
  padding-left:4px;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

.fa-spin {
  animation: spin 2s linear infinite;
}

</style>

